import { profile, axiosConfig } from 'api';

import { Company, CompanyAddressRequest } from 'models/company';
import { Response } from 'models/response';

export const getCompany = async (companyId: string): Promise<Company> => {
  try {
    const response = await profile.get<Response<Company>>(`/Company/${companyId}`, axiosConfig);
    return response.data.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const saveCompanyAddress = async ({
  address,
  description,
  lat,
  lng,
  city_code,
}: CompanyAddressRequest): Promise<Company> => {
  try {
    const response = await profile.put<Response<Company>>(
      '/Company/Address',
      {
        address: address,
        description: description,
        active: true,
        lat: lat,
        lng: lng,
        tag: 'Otros',
        city_code: city_code,
      },
      axiosConfig,
    );
    return response.data.data;
  } catch (error) {
    const message = error.response.data.error ? error.response.data : error;
    return Promise.reject(message);
  }
};

export const saveCompany = async (company: Company): Promise<Company> => {
  try {
    const response = await profile.put<Response<Company>>(
      `/Company/${company.id}`,
      {
        name: `${company.name}`,
        email: `${company.email}`,
        document: `${company.document}`,
        countryId: `${company.countryId}`,
        paymentReferenceCode: `${company.paymentReferenceCode}`,
        onboardingDone: company.onboardingDone,
        bookingAllowed: company.bookingAllowed,
        optimisticPayments: company.optimisticPayments,
        lineOfCreditAvailable: company.lineOfCreditAvailable,
        contactName: `${company.billingInformation?.name}`,
        contactLastName: `${company.billingInformation?.last_name}`,
        contactPhoneNumber: `${company.billingInformation?.phone_number}`,
        contactEmail: `${company.billingInformation?.email}`,
        contactBillingEmail: `${company.billingInformation?.billing_email}`,
      },
      axiosConfig,
    );
    return response.data.data;
  } catch (error) {
    return Promise.reject(error);
  }
};
